import { token } from '@/common/storage'
import * as api from '@/config/api'
import { playTurboHostList } from '@/config/host'
import { NODE_ENV } from '@com/config/env'

export const getToken = () => token.get()

export const setToken = (val) => token.set(val)

export const removeToken = () => token.remove()

export const logout = () => {
  removeToken()
  location.href = api.logoutUrl
}

export const openPageByTokenQuery = (query) => {
  const playTurboUrl = `${playTurboHostList[NODE_ENV]}/#/auth`
  let newTab = window.open('about:blank')
  const queryStr = Object.keys(query)
    .map((key) => `${key}=${encodeURIComponent(query[key])}`)
    .join('&')
  console.log('queryStr', `${playTurboUrl}?${queryStr}`)
  newTab.location.href = `${playTurboUrl}?${queryStr}`
  newTab = null
}
